import styled from 'styled-components';
import {type FC, useRef} from 'react';
import useCenterStore from '../../../store/useCenterStore.ts';
import LogoSVG from '../../../assets/common/logo-sm.svg';
import COMPANYLOGOPNG from '../../../assets/common/company_logo.png';
import type {CenterInfo} from '../../../models';
import InformationSetting from '../InformationSetting.tsx';
import Logo from '../../../compoents/Logo.tsx';
import useModal from '../../../hooks/useModal.tsx';
import useGlobalStore from '../../../store/useGlobalStore.ts';
import {useNavigate} from 'react-router';
import {useFocusable} from '@noriginmedia/norigin-spatial-navigation';

interface HomeIconWrapperProps {
    $focused?: boolean;
}

const HomeIconWrapper = styled.div<HomeIconWrapperProps>`
    grid-area: 1 / 1 / 2 / 2;
    background-color: #242426;
    padding: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 30px;
    outline: none;
    border: 2px solid ${(props) => (props.$focused ? '#fff' : 'transparent')};
    transition: border-color 0.2s ease;
`;

const CenterInfo = styled.div`
    font-size: 0.9rem;
    font-weight: bold;
    margin: 0.2rem 0;
`;

const HomeIcon: FC = () => {
    const centerInfo = useCenterStore((state) => state.centerInfo);

    const clickCountRef = useRef(0);
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const navigate = useNavigate();
    const deviceID = localStorage.getItem('deviceID');

    const {ref, focused} = useFocusable({
        focusKey: 'homeIcon',
        onEnterPress: () => {
            handleImageClick();
        },
    });
    const handleImageClick = () => {
        clickCountRef.current += 1;
        if (clickCountRef.current === 1) {
            timerRef.current = setTimeout(async () => {
                if (clickCountRef.current < 5) {
                    if (deviceID) {
                        window.location.href = `${import.meta.env.VITE_AUTH_API_URL}html/?device_id=${deviceID}`;
                    } else {
                        if (window.electronAPI) {
                            window.electronAPI.hardRefresh();
                        } else {
                            window.location.reload();
                        }
                    }
                }
                clickCountRef.current = 0;
                timerRef.current = null;
            }, 2000);
        }
        if (clickCountRef.current === 5) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
            clickCountRef.current = 0;
            navigate('/error');
        }
    };

    const {generateId} = useGlobalStore();
    const {showModal} = useModal();
    const handleOpenBasicModal = () => {
        showModal(generateId(), InformationSetting);
    };

    return (
        <HomeIconWrapper ref={ref} $focused={focused}>
            <Logo iconWidth={'6.5rem'}>
                <img
                    src={centerInfo?.center_id.startsWith('ICS') ? LogoSVG : COMPANYLOGOPNG}
                    alt={'logo'}
                    onClick={handleImageClick}
                />
            </Logo>
            {centerInfo && (
                <CenterInfo onClick={handleOpenBasicModal}>
                    <h3>{centerInfo.name}</h3>
                    <h3>{centerInfo.center_id}</h3>
                </CenterInfo>
            )}
        </HomeIconWrapper>
    );
};
export default HomeIcon;
